import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectModel } from 'api/dto/Project.dto';
import { PulseTemplateModel } from 'api/dto/PulseTemplate.dto';
import {
  adaptPreviousSurvey,
  adaptProjectTemplate,
  fetchCurrentProjectTemplate,
  fetchProjectTemplateList,
} from 'reduxStore/projectTemplate/asyncActions';
import { ProjectTemplateState, STORE_NAME } from 'reduxStore/projectTemplate/initialState';
import { addAsyncCasesNew } from 'shared/utils/redux';

export const projectTemplateSlice = createSlice({
  name: STORE_NAME,
  initialState: ProjectTemplateState.INITIAL_DOMAIN,
  reducers: {
    clearProjectTemplateList: (state) => {
      state.listResource = ProjectTemplateState.INITIAL_DOMAIN.listResource;
    },
    clearCurrentProjectTemplate: (state) => {
      state.currentResource = ProjectTemplateState.INITIAL_DOMAIN.currentResource;
    },
    updateCurrentProject: (state, action: PayloadAction<{ project: ProjectModel }>) => {
      const currentProject = state.currentResource.data;
      if (currentProject && PulseTemplateModel.isPulseTemplateModel(currentProject)) {
        const updatedTemplate = {
          ...currentProject,
          project: action.payload.project,
        };
        state.currentResource.data = updatedTemplate;
      }
    },
  },
  extraReducers: (builder) => {
    addAsyncCasesNew(builder, fetchProjectTemplateList, (state, action) => {
      state.listResource = action.payload;
    });
    addAsyncCasesNew(builder, fetchCurrentProjectTemplate, (state, action) => {
      state.currentResource = action.payload;
    });
    addAsyncCasesNew(builder, adaptProjectTemplate, (state, action) => {
      state.currentResource = action.payload;
    });
    addAsyncCasesNew(builder, adaptPreviousSurvey, (state, action) => {
      state.currentResource = action.payload;
    });
  },
});

export const { clearProjectTemplateList, clearCurrentProjectTemplate, updateCurrentProject } =
  projectTemplateSlice.actions;
